import { UPDATE_HOTKEYS_STATE } from "./../actions/HotKeysEditor";

const defaultStore = {
	saveRecord: { label: "Сохранить запись", hotKey: "Ctrl + S" },
	view: { label: `Редактирование / Просмотр`, hotKey: "Ctrl + E" },
	confirmDelete: { label: "Подтверждение удаления", hotKey: "Ctrl + Enter" },
	deleteRecord: { label: "Удаление, карточка записи", hotKey: "Ctrl + Del", },
	deleteRecordTable: { label: "Удаление, табличное представление", hotKey: "Ctrl + Del" },
	import: { label: "Импорт", hotKey: "Ctrl + }" },
	export: { label: "Экспорт", hotKey: 'Ctrl + "' },
	close: { label: "Закрыть", hotKey: "Ctrl + Backspace" },
};

// TODO: горячие клавиши из БД
const storageState = sessionStorage.getItem('hotKeys');
const initialState = (storageState && JSON.parse(storageState)) || defaultStore;

export const HotKeysEditorReducer = (store = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case UPDATE_HOTKEYS_STATE: {
			sessionStorage.setItem('hotKeys', JSON.stringify(payload));
			return {
				...store,
				...payload,
			}
		}
		default: return store
	}
}
